import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/General/Home.vue"),
      meta: {}
    },
    {
      path: "/perfil",
      name: "profile",
      component: () =>
        import(/* webpackChunkName: "profile" */ "./views/User/Profile.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Mi perfil"
          }
        ]
      }
    },
    {
      path: "/noticias",
      name: "posts",
      component: () =>
        import(/* webpackChunkName: "posts" */ "./views/Posts/Posts.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias"
          }
        ]
      }
    },
    {
      path: "/corporativas",
      name: "posts-corportiva",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/Corporate.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Noticias Corporativas"
          }
        ]
      }
    },
    {
      path: "/corporativas/:slug",
      name: "corporate-post-show",
      component: () =>
        import(/* webpackChunkName: "post-show" */ "./views/Posts/Show.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias Corporativas"
          }
        ]
      }
    },
    {
      path: "/miscelaneos",
      name: "posts-miscelaneos",
      component: () =>
        import(
          /* webpackChunkName: "miscellaneous-posts" */ "./views/Posts/Miscellaneous.vue"
        ),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Noticias Misceláneas"
          }
        ]
      }
    },
    {
      path: "/conociendonos",
      name: "posts-knowingus",
      component: () =>
        import(/* webpackChunkName: "knowingus-posts" */ "./views/Posts/KnowingUs.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Noticias Conociéndonos"
          }
        ]
      }
    },
    {
      path: "/noticias/:slug",
      name: "post-show",
      component: () =>
        import(/* webpackChunkName: "post-show" */ "./views/Posts/Show.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Noticia"
          }
        ]
      }
    },
    {
      path: "/momentos",
      name: "momentos-security",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/MomentsSecurity.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Momentos"
          }
        ]
      }
    },
    {
      path: "/momentos/:slug",
      name: "post-moment-show",
      component: () =>
        import(/* webpackChunkName: "book-show" */ "./views/Posts/ShowMoments.vue"),
      meta: {
        breadcrumb: [
          { name: "Inicio", link: "/" },
          { name: "Momentos", link: "/momentos" },
          { name: "Momento" }
        ]
      }
    },
    {
      path: "/origen",
      name: "posts-origen",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/Origen.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Origen"
          }
        ]
      }
    },
    {
      path: "/desafio",
      name: "posts-desafio",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/Desafio.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Desafío"
          }
        ]
      }
    },
    {
      path: "/covid19",
      name: "posts-covid19",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/Covid19.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Covid19"
          }
        ]
      }
    },
    {
      path: "/vivo+",
      name: "posts-vivo+",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/Vivo+.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Vivo +"
          }
        ]
      }
    },
    {
      path: "/bbpp-productos-y-servicios-cuenta-corriente",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppProductServicesCC.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Productos y Servicios - Cuenta Corriente"
          }
        ]
      }
    },
    {
      path: "/bbpp-productos-y-servicios-linea-de-credito",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppProductServicesLC"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Productos y Servicios -  Línea de Crédito"
          }
        ]
      }
    },
    {
      path: "/bbpp-productos-y-servicios-seguros",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppProductServicesS"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Productos y Servicios -  Seguros"
          }
        ]
      }
    },
    {
      path: "/bbpp-productos-y-servicios-medios-de-pago",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppProductServicesMP.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Productos y Servicios - Medios de Pago"
          }
        ]
      }
    },
    {
      path: "/bbpp-productos-y-servicios-creditos",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppProductServicesC.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Productos y Servicios - Créditos"
          }
        ]
      }
    },
    {
      path: "/bbpp-productos-y-servicios-creditos-hipotecarios",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppProductServicesCH.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Productos y Servicios - Créditos Hipotecarios"
          }
        ]
      }
    },
    {
      path: "/bbpp-plataformas-digitales-bancosecurity-cl",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppDigitalPlatformsBS.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Plataformas Digitales - bancosecurity.cl"
          }
        ]
      }
    },
    {
      path: "/bbpp-plataformas-digitales-app-security",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppDigitalPlatformsAS.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Plataformas Digitales - App Security"
          }
        ]
      }
    },
    {
      path: "/bbpp-plataformas-digitales-app-security-on",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppDigitalPlatformsASO.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Plataformas Digitales - App Security ON"
          }
        ]
      }
    },
    {
      path: "/bbpp-bajada-comercial-bajada-mensual",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppCommercialDowngradeBM.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Bajada Comercial - Bajada  Mensual"
          }
        ]
      }
    },
    {
      path: "/bbpp-noticias-noticias-destacadas",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppNewsND.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Noticias - Noticias Destacadas"
          }
        ]
      }
    },
    {
      path: "/ciberseguridad",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/Ciberseguridad.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Ciberseguridad"
          }
        ]
      }
    },
    {
      path: "/bbpp-modelo-banca-activa",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppModeloBancaActiva.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Modelo - Banca Activa"
          }
        ]
      }
    },
    {
      path: "/bbpp-modelo-banca-privada",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppModeloBancaPrivada.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Modelo - Banca Privada"
          }
        ]
      }
    },
    {
      path: "/bbpp-modelo-banca-premium",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppModeloBancaPremium.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Modelo – Banca Premium"
          }
        ]
      }
    },
    {
      path: "/bbpp-modelo-banca-empresarios",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppModeloBancaEmpresarios.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Modelo – Banca Empresarios"
          }
        ]
      }
    },
    {
      path: "/bbpp-noticias-origen-al-dia",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppNoticiasOrigenAlDia.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Noticias – Origen al día"
          }
        ]
      }
    },
    {
      path: "/bbpp-noticias-banca-personas-online",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppNoticiasBancaPersonas.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Noticias – Banca Personas Online"
          }
        ]
      }
    },
    {
      path: "/bbpp-productos-y-servicios-comex",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppProductosServiciosComex.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Productos y Servicios – Comex"
          }
        ]
      }
    },
    {
      path: "/bbpp-ranking-una-banca-de-pelicula",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppRanking.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "BBPP Ranking – Una banca de Película"
          }
        ]
      }
    },
    {
      path: "/testimonios",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/Testimonios.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Testimonios"
          }
        ]
      }
    },
    {
      path: "/lado-b",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/LadoB.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Lado B"
          }
        ]
      }
    },
    {
      path: "/somos-security",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/SomosSecurity.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Somos Security"
          }
        ]
      }
    },
    {
      path: "/encuestas-formularios",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/EncuestasFormularios.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Encuestas/Formularios"
          }
        ]
      }
    },
    {
      path: "/mi-evolucion",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/MiEvolucion.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Mi Evolución"
          }
        ]
      }
    },
    {
      path: "/nueva-forma-de-trabajar",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/NuevaFormaDeTrabajar.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Nueva Forma de Trabajar"
          }
        ]
      }
    },
    {
      path: "/incentivos-cliente-integral",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/IncentivosClienteIntegral.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Incentivo Cliente Integral"
          }
        ]
      }
    },
    {
      path: "/tengo-un-dato",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/TengoUnDato.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Tengo un dato"
          }
        ]
      }
    },
    {
    path: "/imprimiendo-el-sello-security",
      component: () =>
        import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/ImprimiendoElSelloSecurity.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Noticias",
            link: "/noticias"
          },
          {
            name: "Imprimiendo el Sello Security"
          }
        ]
      }
    },
    {
      path: "/onboarding",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/Onboarding.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "Onboarding"
            }
          ]
        }
      },
      {
        path: "/bbee-productos-y-servicios-Cuenta-Corriente",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosCC.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "BBEE Productos y Servicios - Cuenta Corriente"
              }
            ]
          }
      },
      {
        path: "/bbee-productos-y-servicios-boleta-de-garantia",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosBG.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "BBEE Productos y Servicios - Boleta de Garantia"
              }
            ]
          }
      },
      {
        path: "/bbee-productos-y-servicios-linea-de-sobregiro",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosLS.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "BBEE Productos y Servicios - Línea de Sobregiro"
              }
            ]
          }
      },
      {
        path: "/bbee-productos-y-servicios-Seguros",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosS.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "BBEE Productos y Servicios - Seguros"
              }
            ]
          }
      },
      {
        path: "/bbee-productos-y-servicios-medios-de-pago",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosMP.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "BBEE Productos y Servicios - Medios de Pago"
              }
            ]
          }
      },
      {
        path: "/bbee-productos-y-servicios-creditos",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosC.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "BBEE Productos y Servicios - Créditos"
              }
            ]
          }
      },
      {
        path: "/bbee-productos-y-servicios-garantias-estatales",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosGE.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "BBEE Productos y Servicios - Garantías Estatáles"
              }
            ]
          }
      },
      {
        path: "/bbee-productos-y-servicios-comex",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosComex.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "BBEE Productos y Servicios - Comex"
              }
            ]
          }
      },
      {
        path: "/bbee-productos-y-servicios-leasing",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosSL.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Productos y Servicios - Leasing"
            }
          ]
        }
      },
      {
        path: "/bbee-productos-y-servicios-banco-sponsor",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosBS.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Productos y Servicios - Banco Sponsor"
            }
          ]
        }
      },
      {
        path: "/bbee-calidad-protocolo-firma-corporativa",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeCalidadPFC.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Calidad - Protocolo Firma Corporativa"
            }
          ]
        }
      },
      {
        path: "/bbee-calidad-protocolo-fuera-oficina",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeCalidadPFOVLM.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Calidad - Protocolo Fuera Oficina (Vacaciones/Licencia Médica)"
            }
          ]
        }
      },
      {
        path: "/bbee-calidad-protocolo-diga",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeCalidadPD.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Calidad - Protocolo DIGA"
            }
          ]
        }
      },
      {
        path: "/bbee-calidad-protocolo-cambio-cartera",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeCalidadPCC.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Calidad - Protocolo Cambio Cartera"
            }
          ]
        }
      },
      {
        path: "/bbee-calidad-como-actualizar-clientes-en-crm",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeCalidadACCRM.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Calidad - Cómo actualizar clientes en CRM"
            }
          ]
        }
      },
      {
        path: "/bbee-esquemas-de-incentivos-esquemas-de-incentivos",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeEsquemaIncentivosEi.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Esquemas de Incentivos - Esquemas de Incentivos"
            }
          ]
        }
      },
      {
        path: "/bbee-campanas-comerciales-campana-productos",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeCampanasComercialesCP.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Campañas Comerciales - Campaña Productos"
            }
          ]
        }
      },
      {
        path: "/bbee-campanas-comerciales-campana-colocaciones",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeCampanasComercialesCC.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Campañas Comerciales - Campaña Colocaciones"
            }
          ]
        }
      },
      {
        path: "/bbee-campanas-comerciales-otras-campanas",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeCampanasComercialesOC.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Campañas Comerciales - Otras Campañas"
            }
          ]
        }
      },
      {
        path: "/bbee-noticias-noticias-destacadas",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeNoticiasND.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Noticias - Noticias Destacadas"
            }
          ]
        }
      },
      {
        path: "/bbee-tarifados-tarifados",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeTarifadosT.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Tarifados - Tarifados"
            }
          ]
        }
      },
      {
        path: "/bbee-procedimientos-procedimientos",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProcedimientosP.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Procedimientos - Procedimientos"
            }
          ]
        }
      },
      {
        path: "/bbee-contactos-contactos",
        component: () =>
          import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeContactosC.vue"),
        meta: {
          breadcrumb: [
            {
              name: "Inicio",
              link: "/"
            },
            {
              name: "Noticias",
              link: "/noticias"
            },
            {
              name: "BBEE Contactos - Contactos"
            }
          ]
        }
      },
      {
        path: "/bbee-productos-y-servicios-mesa-dinero",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosMD.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "BBEE Productos y Servicios - Mesa Dinero"
              }
            ]
          }
      },
      {
        path: "/bbee-productos-y-servicios-cash-management",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeProductosServiciosCM.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "BBEE Productos y Servicios - Cash Management"
              }
            ]
          }
      },
      {
        path: "/conductas-del-desafio",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/ConductasDelDesafio.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "Conductas del Desafío"
              }
            ]
          }
        },
      {
        path: "/conoce-a-tu-Business-Partner",
          component: () =>
            import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/ConoceATuBusinessPartner.vue"),
          meta: {
            breadcrumb: [
              {
                name: "Inicio",
                link: "/"
              },
              {
                name: "Noticias",
                link: "/noticias"
              },
              {
                name: "Conoce a tu Business Partner"
              }
            ]
          }
        },
        {
          path: "/mas-gestion",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/MasGestion.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Más Gestión"
                }
              ]
            }
        },
        {
          path: "/bbee-accesos-directos-crm",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeAccesosDirectosCRM.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "BBEE Accesos Directos - CRM"
                }
              ]
            }
        },
        {
          path: "/bbee-accesos-directos-qliksense",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeAccesosDirectosQ.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "BBEE Accesos Directos - Qliksense"
                }
              ]
            }
        },
        {
          path: "/bbee-accesos-directos-outsystems",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeAccesosDirectosO.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "BBEE Accesos Directos - Outsystems"
                }
              ]
            }
        },
        {
          path: "/bbee-accesos-directos-carpeta-tributaria",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeAccesosDirectosCT.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "BBEE Accesos Directos - Carpeta tributaria"
                }
              ]
            }
        },
        {
          path: "/aprendizaje-sostenible",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/AprendisajeSostenible.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Aprendizaje Sostenible"
                }
              ]
            }
        },
        {
          path: "/procedimientos-de-seguridad",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/ProcedimientosDeSeguridad.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Procedimientos de Seguridad"
                }
              ]
            }
        },
        {
          path: "/ranking-impulsa",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/RankingImpulsa.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Ranking Impulsa"
                }
              ]
            }
        },
        {
          path: "/bbee-accesos-directos-rapidoc",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbeeAccesosDirectosR.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "BBEE Accesos Directos - Rapidoc"
                }
              ]
            }
        },
        {
          path: "/convenio-caja-los-andes",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/ConvenioCLA.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Convenio Caja los Andes"
                }
              ]
            }
        },
        {
          path: "/factoring-novedades-informacion-eventos-factoring",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FactoringInformacionEventosFactoring.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Novedades-Informacion Eventos Factoring"
                }
              ]
            }
        },
        {
          path: "/factoring-novedades-nuestro-dia-a-dia",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FactoringNovedadesNuestroDía.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Novedades-Nuestro Día a Día"
                }
              ]
            }
        },
        {
          path: "/factoring-novedades-noticia-mensual",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FactoringNovedadesNoticiaMensual.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Novedades-Noticia Mensual"
                }
              ]
            }
        },
        {
          path: "/factoring-novedades-tips-para-hacer-mejor-tu-trabajo",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FactoringNovedadesTipsParaHacerMejorTuTrabajo.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Novedades-Tips para hacer mejor tu trabajo"
                }
              ]
            }
        },
        {
          path: "/factoring-nuestros-objetivos-y-avances-logro-de-objetivos",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FNOAvancesLogroObjetivos.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Nuestros Objetivos y Avances-Logro de Objetivos"
                }
              ]
            }
        },
        {
          path: "/factoring-conoce-como-se-hace-nuestros-productos",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FConoceComoSeHaceNuestrosProductos.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Conoce como se hace-Nuestros Productos"
                }
              ]
            }
        },
        {
          path: "/factoring-conoce-como-se-hace-capacitaciones-sobre-nuestros-sistemas",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FCCapacitacionesSobreNuestrosSistemas.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Conoce como se hace-Capacitaciones sobre Nuestros sistemas"
                }
              ]
            }
        },
        {
          path: "/factoring-avances-proyectos-proyectos",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FactoringAvancesProyectosProyectos.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Avances proyectos - Proyectos"
                }
              ]
            }
        },
        {
          path: "/factoring-avances-proyectos-boletines",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FactoringAvancesProyectosBoletines.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Avances proyectos - Boletines"
                }
              ]
            }
        },
        {
          path: "/factoring-avances-proyectos-plan-de-continuidad",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FactoringAvancesProyectosPlanContinuidad.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Avances proyectos - Plan de Continuidad"
                }
              ]
            }
        },
        {
          path: "/factoring-marketing-interno-y-campanas-noticias-y-lanzamiento-de-nuestras-mejoras",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FMICNoticiaslanzamientoNuestrasMejoras.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Marketing Interno y Campañas - Noticias y lanzamiento de nuestras mejoras"
                }
              ]
            }
        },
        {
          path: "/factoring-marketing-interno-y-campanas-campanas",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FactoringMarketingInternoCampañasCampañas.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Marketing Interno y Campañas - Campañas"
                }
              ]
            }
        },
        {
          path: "/factoring-noticias-y-blog-de-actualidad-que-esta-pasando-en-la-industria",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FNBAQueEstaPasandoEnLaIndustria.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Noticias y Blog de Actualidad - Que esta pasando en la industria"
                }
              ]
            }
        },
        {
          path: "/factoring-noticias-y-blog-de-actualidad-informacion-achef-mensual",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FNBAInformacionACHEFMensual.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Factoring-Noticias y Blog de Actualidad - Informacion ACHEF Mensual"
                }
              ]
            }
        },
        {
          path: "/elementos-de-identidad-corporativa",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/ElementosDeIdentidadCorporativa.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Elementos de Identidad Corporativa"
                }
              ]
            }
        },
        {
          path: "/bbee-productos-y-servicios-api",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/ApiBbee.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "BBEE Productos y Servicios - API"
                }
              ]
            }
        },
        {
          path: "/Noticias-core-factoring",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/NoticiasCoreFactoring.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Noticias CORE Factoring"
                }
              ]
            }
        },
        {
          path: "/refiere-y-gana",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/RefiereGana.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Refiere y Gana"
                }
              ]
            }
        },
        {
          path: "/que-es-la-huella",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/QueEsLaHuella.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Qué es la Huella"
                }
              ]
            }
        },
        {
          path: "/voluntarios-security",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/VoluntariosSecurity.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Voluntarios Security"
                }
              ]
            }
        },
        {
          path: "/reciclaje-security",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/ReciclajeSecurity.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Reciclaje Security"
                }
              ]
            }
        },
        {
          path: "/ayuda-ya",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/AyudaYa.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "¡Ayuda Ya!"
                }
              ]
            }
        },
        {
          path: "/vida-avanza",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/VidaAvanza.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Vida Avanza"
                }
              ]
            }
        },
        {
          path: "/bbpp-modelo-regiones",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BBPPModeloRegiones.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "BBPP Modelo – Regiones"
                }
              ]
            }
        },
        {
          path: "/ultimas-noticias",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/UltimasNoticias.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Últimas Noticias"
                }
              ]
            }
        },
        {
          path: "/noticias-proceso-integracion ",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/NoticiasProcesoIntegracion.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Noticias Proceso Integración"
                }
              ]
            }
        },
        {
          path: "/preguntas-y-respuestas-proceso-integracion",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/PreguntasRespuestasProcesoIntegracion.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Preguntas y Respuestas Proceso Integración"
                }
              ]
            }
        },
        {
          path: "/inversiones-security",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/InversionesSecurity.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Inversiones Security"
                }
              ]
            }
        },
        {
          path: "/bbpp-atencion-de-clientes-documentos",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/BbppAtencionDeClientesDocumentos.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "BBPP Atención de Clientes – Documentos"
                }
              ]
            }
        },
        {
          path: "/lideres-que-inspiran",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/LideresQueInspiran.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Líderes que Inspiran"
                }
              ]
            }
        },
        {
          path: "/informacion-del-programa",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/InformacionDelPrograma.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Información del Programa"
                }
              ]
            }
        },
        {
          path: "/material-y-herramientas",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/MaterialYHerramientas.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Material y Herramientas"
                }
              ]
            }
        },
        {
          path: "/fotos-y-videos",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/FotosYVideos.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Fotos y Videos"
                }
              ]
            }
        },
        {
          path: "/Juntas-Somos+",
            component: () =>
              import(/* webpackChunkName: "corporate-posts" */ "./views/Posts/JuntasSomos+.vue"),
            meta: {
              breadcrumb: [
                {
                  name: "Inicio",
                  link: "/"
                },
                {
                  name: "Noticias",
                  link: "/noticias"
                },
                {
                  name: "Juntas Somos+"
                }
              ]
            }
        },
    {
      path: "/avisos-clasificados",
      name: "products",
      component: () =>
        import(
          /* webpackChunkName: "products" */ "./views/Products/Products.vue"
        ),
      props: true,
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Avisos clasificados"
          }
        ]
      }
    },
    {
      path: "/avisos-clasificados/:id",
      name: "product",
      component: () =>
        import(/* webpackChunkName: "product-show" */ "./views/Products/Show.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Avisos"
          }
        ]
      }
    },
    {
      path: "/perfil/mis-avisos",
      name: "my-products",
      component: () =>
        import(
          /* webpackChunkName: "my-products" */ "./views/Products/UserProducts.vue"
        ),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Mis Avisos clasificados"
          }
        ]
      }
    },
    {
      path: "/avisos/nuevo",
      name: "products-create",
      component: () =>
        import(
          /* webpackChunkName: "products-create" */ "./views/Products/ProductCreate.vue"
        ),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Avisos clasificados",
            link: "/avisos-clasificados"
          },
          {
            name: "Crear Aviso"
          }
        ]
      }
    },
    {
      path: "/avisos-clasificados/:id",
      name: "product-show",
      component: () =>
        import(
          /* webpackChunkName: "product-show" */ "./views/Products/Show.vue"
        ),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Avisos clasificados",
            link: "/avisos"
          },
          {
            name: "Ver aviso"
          }
        ]
      }
    },
    {
      path: "/perfil/mis-avisos/:id/edit",
      name: "product-edit",
      component: () =>
        import(
          /* webpackChunkName: "product-edit" */ "./views/Products/ProductEdit.vue"
        ),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Mis Avisos clasificados"
          }
        ]
      }
    },
    {
      path: "/celebremos-nacimientos",
      name: "births",
      component: () =>
        import(/* webpackChunkName: "births" */ "./views/Births/Births.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Celebremos Nacimientos"
          }
        ]
      }
    },
    {
      path: "/celebremos-nacimientos/create",
      name: "births-create",
      component: () =>
        import(
          /* webpackChunkName: "birth-create" */ "./views/Births/BirthCreate.vue"
        ),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Celebremos Nacimientos",
            link: "/celebremos-nacimientos"
          },
          {
            name: "Crear Nacimiento"
          }
        ]
      }
    },
    {
      path: "/celebremos-nacimientos/:id",
      name: "birth-show",
      component: () =>
        import(/* webpackChunkName: "birth-show" */ "./views/Births/Show.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Nacimientos",
            link: "/celebremos-nacimientos"
          },
          {
            name: "Ver Nacimiento"
          }
        ]
      }
    },
    {
      path: "/celebremos-nacimientos/:id/update",
      name: "birth-update",
      component: () =>
        import(
          /* webpackChunkName: "birth-update" */ "./views/Births/Update.vue"
        ),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Nacimientos",
            link: "/celebremos-nacimientos"
          },
          {
            name: "Actualizar"
          }
        ]
      }
    },
    {
      path: "/celebremos-cumpleanos",
      name: "birthdays",
      component: () =>
        import(
          /* webpackChunkName: "birthdays" */ "./views/Birthdays/Birthdays.vue"
        ),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Celebremos Cumpleaños"
          }
        ]
      }
    },
    {
      path: "/encuestas",
      name: "surveys",
      component: () =>
        import(/* webpackChunkName: "surveys" */ "./views/Surveys/Surveys.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Encuestas"
          }
        ]
      }
    },
    {
      path: "/encuestas/:slug",
      name: "survey-show",
      component: () =>
        import(/* webpackChunkName: "survey-show" */ "./views/Surveys/Show.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Encuestas",
            link: "/encuestas"
          },
          {
            name: "Responder Encuesta"
          }
        ]
      }
    },
    {
      path: "/celebremos-bienvenidos",
      name: "welcomes",
      component: () =>
        import(
          /* webpackChunkName: "welcomes" */ "./views/Welcomes/Welcomes.vue"
        ),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Celebremos Bienvenidos"
          }
        ]
      }
    },
    {
      path: "/resultados/:query",
      name: "results",
      component: () =>
        import(
          /* webpackChunkName: "results" */ "./views/Search/Results.vue"
        ),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Resultados"
          }
        ]
      }
    },
    {
      path: "/usuario/:id",
      name: "user-show",
      component: () =>
        import(/* webpackChunkName: "user-show" */ "./views/User/Show.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Buscar"
          }
        ]
      }
    },
    {
      path: "/preguntas-frecuentes",
      name: "faq",
      component: () =>
        import(/* webpackChunkName: "faq" */ "./views/General/Faq.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Preguntas Frecuentes"
          }
        ]
      }
    },
    {
      path: "/beneficios/:id",
      name: "benefit-show",
      component: () =>
        import(/* webpackChunkName: "benefit-show" */ "./views/Benefits/Show.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Beneficios",
            link: "/beneficios"
          },
          {
            name: "Beneficio"
          }
        ]
      }
    },
    {
      path: "/beneficios/:category?",
      name: "benefits",
      component: () =>
        import(/* webpackChunkName: "benefits" */ "./views/Benefits/Benefits.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Beneficios"
          }
        ]
      }
    },
    {
      path: "/biblioteca",
      name: "library",
      component: () =>
        import(/* webpackChunkName: "library" */ "./views/Library/Index.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Biblioteca"
          }
        ]
      }
    },
    {
      path: "/biblioteca/:id",
      name: "book-show",
      component: () =>
        import(/* webpackChunkName: "book-show" */ "./views/Library/Show.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Biblioteca",
            link: "/Libros"
          },
          {
            name: "Libro"
          }
        ]
      }
    },
    {
      path: "/menus/:title",
      name: "menus",
      component: () =>
        import(/* webpackChunkName: "menus" */ "./views/Menus/Show.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Menus"
          }
        ]
      }
    },
    {
      path: "/centro-de-ayuda",
      name: "centro-de-ayuda",
      component: () => import(/* webpackChunkName: "menus" */ "./views/HelpCenter/Index"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Centro de ayuda"
          }
        ]
      }
    },
    {
      path: "/mis-anticipos-de-sueldo",
      name: "anticipos",
      component: () => import(/* webpackChunkName: "menus" */ "./views/AdvancePayments/Index"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Mis Anticipos de Sueldo"
          }
        ]
      }
    },
    // {
    //   path: "/anticipos/solicitar-anticipo",
    //   component: () => import(/* webpackChunkName: "menus" */ "./views/AdvancePayments/newAdvancePayment"),
    // },
    {
      path: "/centro-de-ayuda/crear-caso",
      redirect: "/",
    },
    {
      path: "/centro-de-ayuda/mis-casos",
      component: () => import(/* webpackChunkName: "menus" */ "./views/HelpCenter/IndexTickets"),
    },
    {
      path: "/centro-de-ayuda/mis-casos/:id",
      component: () => import(/* webpackChunkName: "menus" */ "./views/HelpCenter/ShowTicket"),
    },
    {
      path: "/centro-de-ayuda/:category",
      component: () => import(/* webpackChunkName: "menus" */ "./views/HelpCenter/ShowCategory"),
    },
    {
      path: "/centro-de-ayuda/:category/:subcategory",
      component: () => import(/* webpackChunkName: "menus" */ "./views/HelpCenter/ShowSubcategory"),
    },
    {
      path: "/centro-de-ayuda/:category/:subcategory/:question_id",
      component: () => import(/* webpackChunkName: "menus" */ "./views/HelpCenter/ShowQuestion"),
    },
    {
      path: "/protagonistas",
      name: "protagonists",
      component: () =>
        import(/* webpackChunkName: "menus" */ "./views/Protagonists/Index.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Protagonistas"
          }
        ]
      }
    },
    {
      path: "/huella-security",
      name: "Huella Security",
      component: () =>
        import(/* webpackChunkName: "menus" */ "./views/Protagonists/Index.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Huella Security"
          }
        ]
      }
    },
    {
      path: "/proceso-integracion",
      name: "Proceso Integracion",
      component: () =>
        import(/* webpackChunkName: "menus" */ "./views/Protagonists/Index.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Proceso Integración"
          }
        ]
      }
    },
    {
      path: "/programa-lideres-que-inspiran",
      name: "Programa Líderes que Inspiran",
      component: () =>
        import(/* webpackChunkName: "menus" */ "./views/Protagonists/Index.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Programa Líderes que Inspiran"
          }
        ]
      }
    },
    {
      path: "/banca-personas",
      name: "personal-banking",
      component: () =>
        import(/* webpackChunkName: "profile" */ "./views/Menus/PersonalBanking.vue"),
      meta: {
        breadcrumb: [
          {
            name: "Inicio",
            link: "/"
          },
          {
            name: "Banca Personas"
          }
        ]
      }
    },
    {
      path: "/login_standard",
      name: "login_standard",
      component: () =>
        import(/* webpackChunkName: "login-standard" */ "./views/Auth/LoginBice.vue"),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: () =>
        import(/* webpackChunkName: "forgot-password" */ "./views/Auth/ForgotPassword.vue"),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: () =>
        import(/* webpackChunkName: "reset-password" */ "./views/Auth/ResetPassword.vue"),
      meta: {
        requiresAuth: false
      }
    },
  ]
});


// INTENTO DE NO REFRESCAR
router.beforeEach((to, from, next) => {
  // ============================================================
  // PASO 1: Extraer tokens de Azure desde la URL (callback de Azure)
  // Cuando Azure redirige de vuelta, la URL es: https://mi.security.cl/?t=TOKEN&rt=RT&cod=COD&uid=UID#/
  // Los parámetros están ANTES del hash, hay que leerlos con window.location.search
  // ============================================================
  let url = window.location.href;
  let URLObject = new URL(url);
  let urlToken = URLObject.searchParams.get("t");
  let urlCod = URLObject.searchParams.get("cod");
  let urlUid = URLObject.searchParams.get("uid");

  if (urlToken && urlToken.length) {
    // Guardar tokens de Azure en localStorage
    localStorage.setItem("auth_token", urlToken);
    localStorage.setItem("login_method", "azure");
    if (urlUid && urlUid.length) localStorage.setItem("uid", urlUid);
    if (urlCod && urlCod.length) localStorage.setItem("cod", urlCod);
    // Limpiar la URL (quitar los query params) para que no se reprocessen
    window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
  }

  // ============================================================
  // PASO 2: Verificar si hay token y método de login en localStorage
  // ============================================================
  const authToken = localStorage.getItem("auth_token");
  const loginMethod = localStorage.getItem("login_method");

  // Excluir rutas públicas del chequeo de autenticación
  const publicRoutes = ["/login_standard", "/forgot-password", "/reset-password"];

  // Si el usuario ya tiene sesión activa e intenta acceder a rutas de autenticación
  // redirigir al home
  if (publicRoutes.includes(to.path) && authToken && authToken !== "null" && authToken !== "undefined") {
    next({ path: "/" });
    return;
  }

  // Si es una ruta pública y no hay sesión activa, permitir acceso
  if (publicRoutes.includes(to.path) || to.meta.requiresAuth === false) {
    next();
    return;
  }

  if (authToken && authToken !== "null" && authToken !== "undefined") {
    // IMPORTANTE: Siempre validar el token con el backend, sin importar el método
    if (loginMethod === "bice") {
      // Configurar el header de Authorization
      Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;

      // SEGURIDAD: Validar token JWT con el backend
      Vue.axios.get(process.env.VUE_APP_API_URL + "/users/current_user_vue", {
        params: { view_as: "null" }
      })
        .then(response => {
          // Token válido, permitir acceso
          if (response.data && response.data.id) {
            next();
          } else {
            // Token inválido, limpiar y redirigir a Azure (flujo normal)
            console.warn("Token JWT inválido, redirigiendo a Azure");
            localStorage.removeItem("auth_token");
            localStorage.removeItem("login_method");
            localStorage.removeItem("uid");
            window.location.href = process.env.VUE_APP_API_URL + "/azure_auth";
          }
        })
        .catch(error => {
          // Error en la validación (401, 403, etc), redirigir a Azure (flujo normal)
          console.warn("Error validando token JWT:", error.response?.status);
          localStorage.removeItem("auth_token");
          localStorage.removeItem("login_method");
          localStorage.removeItem("uid");
          window.location.href = process.env.VUE_APP_API_URL + "/azure_auth";
        });
      return;
    }

    // Si fue con Azure, validar el token con Azure
    Vue.axios(process.env.VUE_APP_API_URL + "/current_user_azure", {
      params: { referrer: to.path, cod: localStorage.getItem("cod"), url: to.path }
    })
      .then(response => {
        if (response.data.token || response.data.message == "OK") {
          localStorage.setItem("login_method", "azure");
          localStorage.setItem("auth_token", response.data.token || authToken);
          if (response.data.uid) localStorage.setItem("uid", response.data.uid);
          if (response.data.cod) localStorage.setItem("cod", response.data.cod);
          next();
        } else {
          // Token inválido, limpiar y redirigir a Azure
          localStorage.removeItem("auth_token");
          localStorage.removeItem("login_method");
          window.location.href = process.env.VUE_APP_API_URL + "/azure_auth";
          return;
        }
      })
      .catch(() => {
        // Error en la validación, redirigir a Azure
        localStorage.removeItem("auth_token");
        localStorage.removeItem("login_method");
        window.location.href = process.env.VUE_APP_API_URL + "/azure_auth";
        return;
      });
  } else {
    // No hay token, redirigir a Azure
    window.location.href = process.env.VUE_APP_API_URL + "/azure_auth";
    return;
  }
});

export default router;
